//
//
//
//

import { getQueryVariable, getQueryVariable2 } from '@/util/const'
import aes from '@/util/aes'
export default {
  components: {
  },
  data () {
    return {
      accesstoken: getQueryVariable('accesstoken'),
      msisdn: getQueryVariable('msisdn'),
      lang: getQueryVariable('lang'),
      destination_url: getQueryVariable2('destination_url'),
      href: getQueryVariable('href'),
    }
  },
  created () {
    let url = 'accesstoken=' + this.accesstoken + '&msisdn=' + this.msisdn + '&lang=' + this.lang + '&destination_url=' + this.destination_url
    let url1 = aes.encrypt(url)
    let url2 = encodeURIComponent(url1)
    window.location.href = `${this.href}?en=${url2}`
  },
  computed: {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/page/aesUrl.vue